import scoreErrorDictionary from '../../ru/score-error/score-error.dic.json';

export const scoreErrormNS = {
  SCORE_ERROR: scoreErrorDictionary,
};

export const scoreErrorNamespaces = ['SCORE_ERROR'];
